import { Menus } from '@/types/menu';

export const menuData: Menus[] = [
    {
        id: 'xtgl_0',
        title: '系统管理',
        index: '2',
        icon: 'HomeFilled',
        children: [
            {
                id: 'jsgl_1',
                index: '/pages/role',
                title: '角色管理',
            },
        ],
    }
];
export function getMenuItemsByIds(ids: string[]): Menus[] {
    const result: Menus[] = [];

    function findMenuItemsByIds(menuItems: Menus[], ids: string[]): Menus[] {
        const filteredItems: Menus[] = [];
        for (const item of menuItems) {
            if (ids.includes(item.id)) {
                const menuItem = { ...item };
                if (menuItem.children) {
                    menuItem.children = findMenuItemsByIds(menuItem.children, ids);
                }
                filteredItems.push(menuItem);
            } else if (item.children) {
                const filteredChildren = findMenuItemsByIds(item.children, ids);
                if (filteredChildren.length > 0) {
                    filteredItems.push({ ...item, children: filteredChildren });
                }
            }
        }
        return filteredItems;
    }

    findMenuItemsByIds(menuData, ids).forEach(item => result.push(item));
    return result;
}